/**
 * @fileoverview GET handler for the "/apps/transformations/:transformation_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsTransformationsTransformationId } from "./constants";
import type { GetTransformationPayload } from "./types";

export const getTransformationDetail = reactQueryFetcherAdapter(
  appsTransformationsTransformationId,
  (signal: AbortSignal, transformationId: string): Promise<GetTransformationPayload> => {
    return fetch(
      `/apps/transformations/${transformationId}`,
      "GET",
      {},
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
